import React from 'react'

import {Buttons, ButtonPrimary} from '../../ui-kit/Button'
import Animate from '../../ui-kit/Animate'

import {ButtonBlock, TextBlock, Heading, Disclaimer, Paragraph, Item, Content} from '../../styles'

var Text5 = ({onNext, page, pages}) => {

  return (
    <Content>
      <TextBlock>
        <Animate duration=".8s" delay=".3s">
          <Disclaimer>
            Página {page} de {pages}
          </Disclaimer>
          <Heading>
            E aí vamos te dar opções
          </Heading>
        </Animate>

        <Animate duration=".8s" delay="1s">
          <Paragraph>
            <Animate duration=".8s" delay="1s">
              <Item>- A que consideramos <b>a melhor</b></Item>
            </Animate>
            <Animate duration=".8s" delay="1.5s">
              <Item>- Outra <b>mais em conta</b></Item>
            </Animate>
            <Animate duration=".8s" delay="2s">
              <Item>- E uma terceira com um caminho <b>mais rápido</b></Item>
            </Animate>
          </Paragraph>
        </Animate>
      </TextBlock>

      <Animate duration=".3s" delay="3s">
        <ButtonBlock>
          <Buttons>
            <ButtonPrimary onClick={onNext}>
              Próximo
            </ButtonPrimary>
          </Buttons>
        </ButtonBlock>
      </Animate>
    </Content>
  )

}

export default Text5